import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID!,
    authority: process.env.REACT_APP_MSAL_AUTHORITY!,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI!,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    `api://${process.env.REACT_APP_MSAL_CLIENT_ID}/access_as_user`
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
